import { Globe } from 'lucide-react';
import SolutionPage from '../../components/SolutionPage';

export default function ProfessionalWebsites() {
  return (
    <SolutionPage
      label="Solution"
      headline="Your website should build confidence, not hesitation."
      subheadline="A professional online presence is often the first thing a potential customer encounters. How it looks and functions directly affects whether they stay or leave."
      heroImage="https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&w=1920"
      icon={Globe}
      problemTitle="An outdated or unclear website quietly costs business."
      problemBody={[
        'Most businesses underestimate how much their website affects customer decisions. A site that loads slowly, feels dated, or is difficult to navigate creates doubt, even when the business behind it is excellent.',
        'Customers arrive with a question or a need. If the website does not clearly answer that question or guide them toward the next step, many will leave before making contact.',
        'This loss is invisible. The business never knows about the visitors who left without reaching out, the calls that never came, the opportunities that quietly passed.',
      ]}
      outcomes={[
        {
          title: 'A confident first impression',
          description:
            'Visitors form an opinion within seconds. A clean, professionally designed website creates immediate trust and signals that the business takes its presentation seriously.',
        },
        {
          title: 'Clearer navigation and communication',
          description:
            'When information is easy to find and the next step is obvious, customers stay longer and are far more likely to make contact.',
        },
        {
          title: 'Consistent experience across devices',
          description:
            'A properly built website works well on every screen size. Customers arriving from a phone receive the same quality experience as those on a desktop.',
        },
        {
          title: 'Fewer unanswered questions',
          description:
            'Well-structured content anticipates what visitors want to know and answers it directly, reducing hesitation and the need to search elsewhere.',
        },
      ]}
      whatWeDoTitle="We design websites that work as a professional extension of your business."
      whatWeDoBody={[
        'We do not build generic templates. Each website is structured around how your specific business communicates and what your customers actually need to know.',
        'We focus on clarity, load speed, mobile responsiveness, and the quality of the customer journey from first impression to first contact.',
        'Our work does not end at launch. We monitor performance, make refinements, and ensure the website continues to represent your business well over time.',
      ]}
      whatYouGain={[
        'A professional first impression that builds immediate credibility.',
        'Clear pathways that guide visitors toward taking action.',
        'A website that works consistently across all devices and screen sizes.',
        'Reduced customer hesitation and fewer unanswered questions.',
        'A digital presence that accurately reflects the quality of your business.',
        'More time, because your website handles the initial communication for you.',
      ]}
      relatedSolutions={[
        { title: 'Customer Communication', href: '/solutions/customer-communication' },
        { title: 'Lead Qualification', href: '/solutions/lead-qualification' },
        { title: 'Appointment Coordination', href: '/solutions/appointment-coordination' },
      ]}
    />
  );
}
